import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { mapActions } from "vuex";
export default {
  data: function data() {
    return {
      lang: "zh",
      loading: false,
      form: {
        type: 2,
        // 体验
        articleId: "15125255949825486",
        // 分类 体验
        ch: {},
        en: {},
        tw: {},
        ticketName: {}
      },
      categoryList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!_this.$route.query.id) {
              _context.n = 1;
              break;
            }
            _this.getArticleInfo();
            _context.n = 3;
            break;
          case 1:
            _context.n = 2;
            return _this.pageGet({
              instance: _this,
              user: true
            });
          case 2:
            data = _context.v;
            data.form && (_this.form = data.form);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    form: {
      handler: function handler() {
        this.pageSet({
          instance: this,
          user: true
        });
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("d2admin/page", ["close"])), mapActions("d2admin/db", ["pageSet", "pageGet", "pageClear"])), {}, {
    getArticleInfo: function getArticleInfo() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$api.getArticleInfo({
                id: _this2.$route.query.id
              });
            case 1:
              res = _context2.v;
              _this2.form = res.data;
              _this2.loading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.form.en.url = _this3.form.ch.url;
              _this3.form.tw.url = _this3.form.ch.url;
              _this3.form.ticketImg = _this3.form.templateImg;
              if (!_this3.form.id) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return _this3.$api.updateArticle(_this3.form);
            case 1:
              _context3.n = 3;
              break;
            case 2:
              _context3.n = 3;
              return _this3.$api.addArticle(_this3.form);
            case 3:
              _this3.$message.success("操作成功");
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  })
};